import services from '@/services';

export const name = 'transfer-dom';
export default {
  mounted: (el, bindings) => {
    el.classList.add('posb--floating');

    // default append to <body>
    let container = services.document.body;
    if (bindings.arg) {
      container = services.document.getElementById(bindings.arg);
    }

    if (container) {
      if (bindings.modifiers.prepend && container.firstChild) {
        container.insertBefore(el, container.firstChild);  // top of target
      } else {
        container.appendChild(el); // bottom of target
      }
    } else {
      services.ga.exceptionTrack(`v-${name} target element id "${bindings.arg}" not found`);
    }
  },
  unmounted: el => {
    el.parentNode.removeChild(el);
  },
};
